import React from 'react'
import { isMobile } from 'react-device-detect'
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';

export default function PaymentPagamerCtrl() {
  return (
    <div>PaymentPagamerCtrl</div>
  )
}
